import * as yup from 'yup';
import * as v from 'src/utils/form/validate';

const maxNameLength = 100;
const maxDescriptionLength = 2000;

export default function getValidationSchema() {
  const validationSchema = yup.object({
    title: v.validateName(yup, "ім'я", maxNameLength) as yup.StringSchema<string, yup.AnyObject, ''>,
    organizer: v.validateName(yup, 'Організатор', maxNameLength) as yup.StringSchema<string, yup.AnyObject, ''>,
    url: v.validateUrl(yup) as yup.StringSchema<string, yup.AnyObject, ''>,
    scheduledAt: v.validateDateTime(yup) as yup.MixedSchema<Date | number | null>,
    locationId: yup.string().required("обов'язкове поле"),
    phone: v.validatePhone(yup) as yup.StringSchema<string, yup.AnyObject, ''>,
    email: v.validateEmail(yup) as yup.StringSchema<string, yup.AnyObject, ''>,
    description: v.validateName(yup, 'опис', maxDescriptionLength, false) as yup.StringSchema<
      string | undefined,
      yup.AnyObject,
      undefined,
      ''
    >
  });

  return validationSchema;
}
